import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Dialog } from '@headlessui/react';
import Accordion from '../utils/accordion';
import IconClose from '../utils/icon/close.svg';

// eslint-disable-next-line no-unused-vars
const ClearForMe = ({ currentProduct, currentVariant }) => {
  const [ingredients, setIngredients] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);

  const clientName = 'nest';
  const validationToken =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1ZjQzZGQ1MjdjMzAxMzM2OWM4ODJlNmUiLCJzdG9yZVVybCI6Imh0dHBzOi8vd3d3Lm5lc3RuZXd5b3JrLmNvbS8iLCJpYXQiOjE2NjU1ODk3Njl9.YJCo3Y5rQSj_U-SKiqBLGbzr-kteDoIrcHraiuqwZCM';

  async function fetchProductIngredients() {
    const response = await fetch(
      // eslint-disable-next-line max-len
      `https://clickable-api.clearforme.com/api/app/products/details/v2?clientname=${clientName}&sku=${currentVariant?.sku}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${validationToken}`,
        },
      },
    );

    if (response.ok) {
      const resp = await response.json();
      setIngredients(resp?.productIngredients);
    } else {
      setIngredients(null);
      // eslint-disable-next-line no-console
      console.log(
        'Clear For Me: unable to retrieve ingredients or no ingredients available for this sku.',
      );
    }
  }

  async function handleIngredientClick({
    productIngredientId,
    cfmIngredientId,
  }) {
    const response = await fetch(
      // eslint-disable-next-line max-len
      `https://clickable-api.clearforme.com/api/app/ingredients/definition/v2?clientname=${clientName}&productIngredientId=${productIngredientId}&cfmIngredientId=${cfmIngredientId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${validationToken}`,
        },
      },
    );

    const ingredientDetails = await response.json();
    setDialogData(ingredientDetails);
    setIsDialogOpen(true);
  }

  useEffect(() => {
    fetchProductIngredients();
  }, [currentVariant?.sku]);

  return !ingredients ? null : (
    <>
      <Dialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        className="relative z-50"
      >
        <div className="fixed p-[15px] inset-0 flex items-center justify-center bg-black bg-opacity-40 cursor-pointer">
          <Dialog.Panel className="w-full relative max-w-[576px] laptop:p-9  p-[18px] rounded bg-white cursor-default">
            <button
              className="absolute right-3 top-3"
              onClick={() => setIsDialogOpen(false)}
            >
              <IconClose />
            </button>
            <Dialog.Title className="subheading-h2 laptop:mb-[30px] mb-6 capitalize ">
              {dialogData?.ingredientName || 'No ingredient details'}
            </Dialog.Title>
            {!dialogData && (
              <p>{window.TMW.Strings.accordions.keyIngredientsError}</p>
            )}
            {dialogData && (
              <div>
                <p className="font-base laptop:font-16 font-14 mb-[21px]">
                  {dialogData?.definition}
                </p>
                <p className="font-base laptop:font-16 font-14 mb-[21px]">
                  <span className="font-medium">Functions: </span>
                  {dialogData?.functions?.map((func) => (
                    <span key={func.attribute}>{func.attribute} </span>
                  ))}
                </p>
                <p className="text-right">
                  <a
                    href="https://clearforme.com"
                    target="_blank"
                    rel="noreferrer"
                    className="utility-2 tracking-[2.4px]"
                  >
                    POWERED BY CLEARFORME
                  </a>
                </p>
              </div>
            )}
          </Dialog.Panel>
        </div>
      </Dialog>
      <Accordion
        title={window.TMW.Strings.accordions.keyIngredientsHeading}
        classes={{
          accordion:
            'gap-5 py-[17px] border-black-30 px-[20px] laptop:px-0  border-t laptop:pr-2.5 pr-2.5',
          title: 'subheading-h4 text-black',
          content:
            'overflow-hidden max-h-[0px] transition-all duration-300 px-[20px] laptop:px-0',
        }}
      >
        {ingredients.map((ingredientGroup) => (
          <div key={ingredientGroup.component} className="mb-5">
            <p className="font-13-bold mb-2 capitalize">
              {ingredientGroup.component}
            </p>
            <p className="leading-[18px]">
              {ingredientGroup.ingredientGroup[0].ingredients.map(
                (ingredient) => (
                  <a
                    className="inline-block mr-2 cursor-pointer capitalize font-13"
                    key={ingredient.productIngredientId}
                    onClick={(e) => {
                      e.preventDefault();
                      handleIngredientClick({
                        cfmIngredientId: ingredient.cfmIngredientId,
                        productIngredientId: ingredient.productIngredientId,
                      });
                    }}
                  >
                    {ingredient.ingredientName},
                  </a>
                ),
              )}
            </p>
          </div>
        ))}
      </Accordion>
    </>
  );
};

export default ClearForMe;
